import apiClient from "../api/apiClient";
import { API_ENDPOINTS } from "../api/endpoints";

let countryMap = null;
let countryPromise = null;

export const getCountryMap = async () => {
  if (countryMap) return countryMap;

  if (countryPromise) return countryPromise;

  countryPromise = apiClient({
    url: API_ENDPOINTS.GET_COUNTRIES,
    method: "get",
    withAuth: true,
  })
    .then((res) => {
      const map = {};
      res?.data?.countries?.forEach((c) => {
        map[c.iso2] = c.name; // 👈 IN → India
      });
      countryMap = map;
      return map;
    })
    .catch(() => ({}))
    .finally(() => {
      countryPromise = null;
    });

  return countryPromise;
};
